import React from "react";
import { Gauge, ScanLine, Target, CalendarCheck2 } from "lucide-react";

const pct = (v) => (v == null ? "—" : `${Math.round(v * 100)}%`);

/* 扫码统计：扫码占比 / 准确率 / 今日次数 / 近 30 天会话 */
export const ScanStats = ({ stats, zh }) => {
  const T = (a, b) => (zh ? a : b);
  if (!stats) return null;
  const items = [
    { k: "ratio", icon: ScanLine, label: T("扫码出入库占比", "Scan share"), val: pct(stats.scanRatio), sub: T(`扫码 ${stats.scanMoves} · 手工 ${stats.manualMoves}`, `${stats.scanMoves} scan · ${stats.manualMoves} manual`), tone: "text-indigo-600" },
    { k: "accuracy", icon: Target, label: T("扫码准确率", "Accuracy"), val: pct(stats.accuracy), sub: T(`成功 ${stats.applied} · 拦截 ${stats.failed}`, `${stats.applied} ok · ${stats.failed} blocked`), tone: stats.accuracy != null && stats.accuracy < 0.9 ? "text-amber-600" : "text-emerald-600" },
    { k: "today", icon: CalendarCheck2, label: T("今日扫码提交", "Today"), val: stats.todaySessions, sub: T(`近 ${stats.days} 天共 ${stats.sessions} 次`, `${stats.sessions} in ${stats.days}d`), tone: "text-slate-800" },
    { k: "device", icon: Gauge, label: T("设备", "Devices"), val: Object.entries(stats.byDevice || {}).map(([d, n]) => `${{ camera: T("摄像头", "cam"), scanner: T("扫码枪", "gun"), manual: T("手输", "manual") }[d] || d} ${n}`).join(" · ") || "—", sub: T("摄像头 / 扫码枪 / 手输", "camera / scanner / manual"), tone: "text-slate-800", small: true },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-testid="wms-stats">
      {items.map((it) => (
        <div key={it.k} className="rounded-xl border border-slate-200 bg-white px-3 py-2" data-testid={`wms-stat-${it.k}`}>
          <p className="text-[10px] text-slate-400 inline-flex items-center gap-1"><it.icon className="h-3 w-3" />{it.label}</p>
          <p className={`${it.small ? "text-xs" : "text-xl"} font-black ${it.tone} leading-tight mt-0.5`}>{it.val}</p>
          <p className="text-[10px] text-slate-400">{it.sub}</p>
        </div>
      ))}
    </div>
  );
};
